import { useMemo } from 'react';

import { TenantBankAccount } from '@work4all/models/lib/Classes/TenantBankAccount.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const useTenantBankAccountRequestData = (id: string | number) => {
  return useMemo<DataRequest>(() => {
    const tenantBankAccountRequestData: TenantBankAccount<EMode.query> = {
      id: null,
      name: null,
      accountOwner: null,
      mainAccount: null,
      iban: null,
      bic: null,
      sEPACreditorId: null,
      ledgerAccount: {
        id: null,
        name: null,
        number: null,
      },
      ledgerAccountId: null,
    };
    const filter = [{ id: { $eq: id } }];
    const data = tenantBankAccountRequestData;
    return {
      entity: Entities.tenantBankAccount,
      data,
      filter,
      completeDataResponse: true,
    };
  }, [id]);
};
